import type { SVGProps } from 'react';
const SvgLongArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={12} fill="none" {...props}>
    <path d="M12.65 5.65h-12m4.8 5-4.8-5 4.8-5" />
  </svg>
);
export default SvgLongArrowIcon;
